import {Text} from '@wix/wix-ui-tpa/cssVars';
import {TextPriority} from '@wix/wix-ui-tpa';
import React from 'react';
import {useLocaleKeys} from '../../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../../Widget/ControllerContext';
import {classes} from './PlaceOrderTitle.st.css';

export enum PlaceOrderTitleDataHook {
  title = 'PlaceOrderTitleDataHook.title',
  subtitle = 'PlaceOrderTitleDataHook.subtitle',
}

export const PlaceOrderTitle = () => {
  const localeKeys = useLocaleKeys();
  const {
    navigationStore: {isDonationsTheme},
    checkoutSettingsStore: {checkoutContent},
    checkoutStore: {cartSummary},
  } = useControllerProps();
  const reviewOrderText = isDonationsTheme
    ? localeKeys.checkout.donations.review_donation.title()
    : localeKeys.checkout.place_order.$value();
  const reviewOrderTextWithOverride = checkoutContent?.reviewAndPlaceOrder ?? reviewOrderText;
  const shouldHideTitle = !cartSummary!.paymentSummary.requiresPaymentAfterGiftCard;
  return (
    <>
      {!shouldHideTitle && (
        <div className={classes.title}>
          <Text
            data-hook={PlaceOrderTitleDataHook.title}
            tagName={'h2'}
            priority={TextPriority.primary}
            className={classes.titleText}>
            {reviewOrderTextWithOverride}
          </Text>
        </div>
      )}
      <div className={classes.subtitle}>
        <Text data-hook={PlaceOrderTitleDataHook.subtitle}>
          {isDonationsTheme
            ? localeKeys.checkout.donations.review_donation.description()
            : localeKeys.checkout.place_order.description()}
        </Text>
      </div>
    </>
  );
};
